@let blok = block();
@let appear = appearance();
@let siz = size();
@let scrollHeightInPx = scrollHeight();

<ng-template #sectionHeadline let-hasSize="hasSize" let-size="size">
  <button (click)="toggle()"
          [class.hidden]="size === 'comfort' || size === 'premium'"
          [class.is-selected]="appear === '3-columns' && size === tariffStore.size$()"
          [class.is-topseller]="appear === '3-columns' && size === topsellerTariff()"
          [class.md:block]="size === 'comfort' || size === 'premium'"
          [class.md:pl-5]="hasSize"
          [class]="baseClass + '--title'"
          [tabindex]="-1"
          class="text-lg font-bold py-6 d-block w-full text-left pl-6 app-ellipsis">
    {{ blok.title }}
  </button>
</ng-template>
<div [ngClass]="[baseClass, baseClass + '-' + appear]">
  <div [class.without-size]="!siz"
       [class]="baseClass + '--header'"
       class="bg-primary10">
    @if (siz) {
      <ng-container
        *ngTemplateOutlet="sectionHeadline;context:{size: siz, hasSize: !!siz}"/>
    } @else {
      @for (index of [0, 1, 2]; track index) {
        @if (index === 0 || (appear === '3-columns' && (index === 1 || index === 2))) {
          <ng-container
            *ngTemplateOutlet="sectionHeadline;context:{size: index | indexToTariffSize, hasSize: !!siz}"/>
        }
      }
    }
  </div>
  @if (blok.entries?.length) {
    <div [class.is-collapsed]="collapsed()"
         [class]="baseClass + '--entries'"
         #entriesElem
         [ngStyle]="{'--tariff-section-scroll-height': (scrollHeightInPx+'px' || 4000+'px')} "
    >
      @for (child of blok.entries; track child['_uid'];) {
          <app-tariff-entry [block]="child"
                            [tariff]="tariff()"
                            [size]="siz"
                            [appearance]="appear"
                            [selectedIcon]="selectedIcon()"
                            [selectedIconActive]="selectedIconActive()"
                            [unselectedIcon]="unselectedIcon()"
                            [topsellerTariff]="topsellerTariff()"
                            [topsellerText]="topsellerText()" />
      }
    </div>
  }
</div>

